import { styled as o } from "styled-components";
import { Colors as n } from "../../styles/colors/index.js";
import { Icon as r } from "../Icon/index.js";
const l = o.span`
  display: inline-flex;
  align-items: center;
`, m = o(r)`
  color: rgb(${n.Alien});
  font-size: 24px;
  margin-left: 4px;
`;
export {
  l as NicknameContainer,
  m as TopCreatorIcon
};
